import { ArrowLeft, ArrowRight } from '@mui/icons-material'
import { Button, Card, CardContent, Divider, Grid } from '@mui/material'
import { GreenText } from 'components'
import { VehicleDamageDto } from 'dtos'
import { useDialogState } from 'hooks'
import React, { useState } from 'react'
import AddDamagePhotoCard from '../AddDamagePhotoCard'
import AddDamageStepper from './AddDamageStepper'
import DamagePhoto1Dialog from './DamagePhoto1Dialog'

interface Step3DamagePhotosProps {
  damage: VehicleDamageDto
  onBack: () => void
  onNext: () => void
  setDamage: React.Dispatch<React.SetStateAction<VehicleDamageDto>>
}

export default function Step3DamagePhotos({ damage, onBack, onNext, setDamage }: Step3DamagePhotosProps) {
  const [photo, setPhoto] = useState<1 | 2 | 3>(1)

  const [dialogState, setDialogState] = useDialogState({
    damagePhoto1DialogOpen: false
  })

  return (
    <>
      {dialogState.damagePhoto1DialogOpen && (
        <DamagePhoto1Dialog
          damagePhoto={damage[`damagePhoto${photo}File`]}
          onClose={() => {
            setDialogState('damagePhoto1DialogOpen', false)
          }}
          onDelete={() => {
            setDamage({
              ...damage,
              [`damagePhoto${photo}File`]: undefined
            })
            setDialogState('damagePhoto1DialogOpen', false)
          }}
          onSave={damagePhoto => {
            setDamage({
              ...damage,
              [`damagePhoto${photo}File`]: damagePhoto
            })
            setDialogState('damagePhoto1DialogOpen', false)
          }}
          open={dialogState.damagePhoto1DialogOpen}
          photo={photo}
        />
      )}

      <Card>
        <CardContent>
          <Grid container spacing={1} alignItems='center'>
            <Grid item xs={12}>
              <AddDamageStepper activeStep={2} />
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid container item xs={12} direction='column' spacing={2}>
              <Grid item>
                <AddDamagePhotoCard
                  complete={damage.damagePhoto1File !== undefined}
                  damagePhoto={damage.damagePhoto1File}
                  disabled={false}
                  onClick={() => {
                    setPhoto(1)
                    setDialogState('damagePhoto1DialogOpen', true)
                  }}
                  photo={1}
                  warning={undefined}
                />
              </Grid>

              <Grid item>
                <AddDamagePhotoCard
                  complete={damage.damagePhoto2File !== undefined}
                  damagePhoto={damage.damagePhoto2File}
                  disabled={false}
                  onClick={() => {
                    setPhoto(2)
                    setDialogState('damagePhoto1DialogOpen', true)
                  }}
                  photo={2}
                  warning={undefined}
                />
              </Grid>

              <Grid item>
                <AddDamagePhotoCard
                  complete={damage.damagePhoto3File !== undefined}
                  damagePhoto={damage.damagePhoto3File}
                  disabled={false}
                  onClick={() => {
                    setPhoto(3)
                    setDialogState('damagePhoto1DialogOpen', true)
                  }}
                  photo={3}
                  warning={undefined}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} marginTop={2}>
              <Button color='primary' endIcon={<ArrowRight />} fullWidth onClick={onNext} type='submit' variant='contained'>
                NEXT
              </Button>
            </Grid>

            <Grid item xs={12}>
              <Button color='primary' startIcon={<ArrowLeft />} fullWidth onClick={onBack} variant='outlined'>
                PREVIOUS
              </Button>
            </Grid>

            <Grid item xs={12}>
              <GreenText variant='outlined'>
                {`**Vehicle Damage Steps:**

Displays the current step of the vehicle in the Damage 
process.

**Damage Photos:**

Displays the Damage Photos uploaded by the user.

If no image has been uploaded, a “No Image” icon will be 
displayed instead.

Users can upload up to 3 damage photos.

Clicking on any of the uploaded Damage Photo images will 
open the Capture Damage Photo Dialog.

Photos are not required to submit the damage record.

**Next Button:**

Clicking the Next Button will take the user to the next step in 
the Damage process.

- Save changes made during the current step.

- Advance the user to the next step in the Damage process.

**PREVIOUS Button:**

Clicking this button will:

- Discard any changes made in the current step.

- Return the user to the previous step in the Damage process.`}
              </GreenText>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
